// eslint-disable-next-line import/no-named-as-default
import { api } from './base.service';

// http://localhost:7025/engine/user-on-day-shifts/user/id  ???
// localhost:7025/engine/user-on-day-shifts/user/next-n-days?userId=1132&date=2023-01-01+09:46:52&nextNDays=10

export const getWeeklySchedule = (numberOfDays) => {
    return api().get(`/api/schedules/monthly?nextNDays=${numberOfDays}`);
};
